module.exports = __webpack_public_path__ + "img/andriod1.77ed0b0b.png";